export const enum EMortgageOffersTabs {
  Banks = 'banks',
  Mortgage = 'mortgage',
}
